export default (
  id?: MaybeRefOrGetter<string | undefined>
): ComputedRef<string> => computed(() => toValue(id) || useId());
